module.exports = __webpack_public_path__ + "img/peaceJamHeadquarters.37fc1ed5.jpg";